// localStorage boolean read through useStoredBoolean: "always open /open/* links in the desktop app".
export const openInDesktopAppKey = 'griply.open-in-desktop-app';

// Session-only hand-off from the /open/* loader to the message in the app shell; survives the login redirect.
const pendingDesktopLaunchKey = 'griply.open-in-desktop.pending';

export const setPendingDesktopLaunch = (linkPath: string): void => {
  try {
    window.sessionStorage.setItem(pendingDesktopLaunchKey, linkPath);
  } catch {
    // storage unavailable
  }
};

export const getPendingDesktopLaunch = (): string | null => {
  try {
    return window.sessionStorage.getItem(pendingDesktopLaunchKey);
  } catch {
    return null;
  }
};

export const clearPendingDesktopLaunch = (): void => {
  try {
    window.sessionStorage.removeItem(pendingDesktopLaunchKey);
  } catch {
    // storage unavailable
  }
};
